import { NgModule } from "@angular/core";
import { PhotosSelectComponent } from "./photos-select-form.component";

import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule.forChild({})],
  exports: [PhotosSelectComponent],
  declarations: [PhotosSelectComponent],
  providers: [],
})
export class PhotosSelectModule {}
